import { Box, Dialog, IconButton, TableCell, TableRow, Theme, Typography } from "@mui/material";
import { ColorMap, TableHeaderData } from "../investorOverview/types";
// import { ViewOutlinedIcon } from "../../assets/SvgIcons";
import { BankListObj } from "../../redux-store/actions/bank";
import dayjs from "dayjs";


export const viewBankTableHeader: TableHeaderData[] = [
    {
        id: "investorName",
        label: "Investor Name",
        align: "left",
        isSortable: true,
    },
    {
        id: "bankName",
        label: "Bank Name",
        align: "center",
        isSortable: true,
    },
    {
        id: "ifscCode",
        label: "IFSC Code",
        align: "center",
        isSortable: true,
    },
    {
        id:"bankAccountNumber",
        label: "Account Number",
        align: "center",
        isSortable: true,
    },
    {
        id: "uccCode",
        label: "UCC Code",
        align: "center",
        isSortable: true,
    },
    {
        id: "accountType",
        label: "Account Type",
        align: "center",
        isSortable: true,
    },
    {
        id: "updatedAt",
        label: "UPDATED AT",
        align: "center",
        isSortable: true,

    },
    {
        id: "status",
        label: "Status",
        align: "center",
        isSortable: true,
    },
    {
        id: "bseStatus",
        label: "BSE Status",
        align: "center",
        isSortable: false,
    },
    // {
    //     id: "actions",
    //     label: "Actions",
    //     align: "center",
    //     isSortable: false
    // }
     {
        id: "mpowerStatus",
        label: "MPOWER Status",
        align: "center",
        isSortable: false,
    },
    
]
export interface ViewBankItem {
    investorName: string;
    bankName: string;
    ifscCode: string;
    uccCode: string;
    accountType: string;
    status: string;
}

export default function ViewBankTableBody({ data }: {
    data: any,
}): JSX.Element {
    const colorMap: ColorMap = {
        approved: "success.500",
        "approved by checker": "success.500",
        "approved by payment checker": "success.500",
        "payment success": "success.500",
        rejected: "error.500",
        "rejected by checker": "error.500",
        "rejected by payment checker": "error.500",
        pending: 'warning.500',
    }

    return (
        <>
            {data?.map((obj: BankListObj) => {
                return (
                    <TableRow
                        key={`${obj?.investorName}-${obj?.id}`}
                        sx={(theme: Theme) => ({
                            '& td': {
                                paddingTop: "15px",
                                paddingBottom: "15px",
                                borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                            },
                            '& td:first-of-type': {
                                paddingLeft: "0px"
                            },
                        })}
                    >
                        <TableCell align="left">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.primary[500],
                                })}
                            >
                                {obj?.investorName ?? "-"}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary,
                                })}
                            >
                                {obj?.bankName ?? '-'}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary,
                                })}
                            >
                                {obj?.ifscCode ?? '-'}
                            </Typography>
                        </TableCell>
                        
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary,
                                })}
                            >
                                {obj?.bankAccountNumber ?? '-'}
                            </Typography>
                        </TableCell>
                        
                        
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary,
                                })}
                            >
                                {obj?.clientCode ?? '-'}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary,
                                })}
                            >
                                {obj?.bankAccountType ?? "-"}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary,
                                })}
                            >
                                {
                                    `${obj?.updatedAt ?? ""}`?.length ?
                                        dayjs(obj?.updatedAt).format('DD/MM/YYYY') : "-"
                                }
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: colorMap[obj?.status?.toLowerCase() ?? ""] ? colorMap[obj?.status?.toLowerCase() ?? ""] : theme.palette.text.primary,
                                })}
                            >
                                {obj?.status ?? '-'}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                })}
                            >
                                {obj?.bseStatus ?? '-'}
                            </Typography>
                        </TableCell>
                        {/* <TableCell align="center">
                            <Box sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                <ViewOutlinedIcon />
                                <Typography variant="body_500" sx={(theme: Theme) => ({
                                    color: theme.palette.customColors.hyperlinkBlue
                                })}>
                                    View
                                </Typography>
                            </Box>
                        </TableCell> */}
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                })}
                            >
                                {obj?.mpowerStatus ?? '-'}
                            </Typography>
                        </TableCell>
                    </TableRow>
                )
            })}
        </>

    )
}


export function ViewBankTableBodyResponsive({
    data,
    tableHeaderData,
}: {
    data: BankListObj[];
    tableHeaderData: TableHeaderData[];
}): JSX.Element {
    const colorMap: ColorMap = {
        approved: "success.500",
        "approved by checker": "success.500",
        "approved by payment checker": "success.500",
        "payment success": "success.500",
        rejected: "error.500",
        "rejected by checker": "error.500",
        "rejected by payment checker": "error.500",
        pending: 'warning.500',
    }

    const label = (id: string): string => tableHeaderData.find(h => h.id === id)?.label ?? '';

    return (
        <>
            {data?.map((obj: BankListObj) => (
                <Box
                    key={`${obj?.investorName}-${obj?.id}`}
                    sx={(theme: Theme) => ({
                        border: `1px solid ${theme.palette.grey[200]}`,
                        borderRadius: '12px',
                        padding: '16px',
                        marginBottom: '16px',
                        backgroundColor: theme.palette.common.white,
                        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
                    })}
                >
                    <Box sx={{ marginBottom: '12px' }}>
                        <Typography variant="body_500" sx={(theme: Theme) => ({
                            color: theme.palette.primary[500],
                            fontWeight: 600,
                        })}>
                            {obj?.investorName ?? '-'}
                        </Typography>
                    </Box>

                    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                        <Box>
                            <Typography variant="caption" sx={(theme: Theme) => ({ color: theme.palette.text.secondary })}>
                                {label('bankName')}
                            </Typography>
                            <Typography variant="body_500">{obj?.bankName ?? '-'}</Typography>
                        </Box>
                        <Box sx={{ textAlign: 'right' }}>
                            <Typography variant="caption" sx={(theme: Theme) => ({ color: theme.palette.text.secondary })}>
                                {label('ifscCode')}
                            </Typography>
                            <Typography variant="body_500">{obj?.ifscCode ?? '-'}</Typography>
                        </Box>

                        <Box>
                            <Typography variant="caption" sx={(theme: Theme) => ({ color: theme.palette.text.secondary })}>
                                {label('bankAccountNumber')}
                            </Typography>
                            <Typography variant="body_500">{obj?.bankAccountNumber ?? '-'}</Typography>
                        </Box>
                        <Box sx={{ textAlign: 'right' }}>
                            <Typography variant="caption" sx={(theme: Theme) => ({ color: theme.palette.text.secondary })}>
                                {label('uccCode')}
                            </Typography>
                            <Typography variant="body_500">{(obj as any)?.clientCode ?? '-'}</Typography>
                        </Box>

                        <Box>
                            <Typography variant="caption" sx={(theme: Theme) => ({ color: theme.palette.text.secondary })}>
                                {label('accountType')}
                            </Typography>
                            <Typography variant="body_500">{(obj as any)?.bankAccountType ?? '-'}</Typography>
                        </Box>
                        <Box sx={{ textAlign: 'right' }}>
                            <Typography variant="caption" sx={(theme: Theme) => ({ color: theme.palette.text.secondary })}>
                                {label('updatedAt')}
                            </Typography>
                            <Typography variant="body_500">{`${obj?.updatedAt ?? ''}`?.length ? dayjs(obj?.updatedAt).format('DD/MM/YYYY') : '-'}</Typography>
                        </Box>

                        <Box>
                            <Typography variant="caption" sx={(theme: Theme) => ({ color: theme.palette.text.secondary })}>
                                {label('status')}
                            </Typography>
                            <Typography variant="body_500" sx={(theme: Theme) => ({
                                color: colorMap[obj?.status?.toLowerCase() ?? ""] ? colorMap[obj?.status?.toLowerCase() ?? ""] : theme.palette.text.primary,
                            })}>{obj?.status ?? '-'}</Typography>
                        </Box>
                        <Box sx={{ textAlign: 'right' }}>
                            <Typography variant="caption" sx={(theme: Theme) => ({ color: theme.palette.text.secondary })}>
                                {label('bseStatus')}
                            </Typography>
                            <Typography variant="body_500">{(obj as any)?.bseStatus ?? '-'}</Typography>
                        </Box>
                    </Box>
                </Box>
            ))}
        </>
    )
}